/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOptionsCommand
 */
export interface UpdateOptionsCommand {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateOptionsCommand
     */
    options?: { [key: string]: any; } | null;
}

export function UpdateOptionsCommandFromJSON(json: any): UpdateOptionsCommand {
    return UpdateOptionsCommandFromJSONTyped(json, false);
}

export function UpdateOptionsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOptionsCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function UpdateOptionsCommandToJSON(value?: UpdateOptionsCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': value.options,
    };
}


